// utils/validateProduct.js
import { isValidHttpUrl } from './url';

export function validateProductInput({
  product,
  price,
  description,
  selectedCategory,
  selectedSubCategory,
  externalUrl,
}) {
  if (!product?.trim()) return 'Product name is required.';
  if (!price || isNaN(price) || parseFloat(price) <= 0)
    return 'Valid price is required.';
  if (!description?.trim()) return 'Description is required.';
  if (!selectedCategory) return 'Category is required.';
  if (!selectedSubCategory) return 'Sub-category is required.';
  if (!externalUrl?.trim() || !isValidHttpUrl(externalUrl))
    return 'A valid http(s) product URL is required.';
  return null;
}
